import {on, trigger} from './util/event'
import api from './api'
import {openModal} from "./modal"


const changeEventName               = 'change.kiosk.userSubscription';
let       subscriptionStatus,
          checkerUrl,
          checkFailUrl,
          statusChecker,
          statusCheckerTimer,
          statusCheckerStartAt,
          statusCheckerCnt = 0;

// send request
// if answer - error - show error msg (inherit)
// if answer - ok, wait response - still show loader and check subs status
// если закрыл или ушел со страницы или попытался открыть снова или из хидера - ?

// Start from checking
// save current status and compare with new status from response
//

on(changeEventName, function(e) {
  const eventData = e.detail;

  subscriptionStatus = eventData.status;
  checkerUrl         = eventData.checkerUrl || null;
  checkFailUrl       = eventData.checkFailUrl || null;

  // start status check
  statusCheckerStartAt = +new Date();
  statusCheckerTimer = setTimeout(function(){
    statusChecker();
  }, 1000);

});

statusChecker = function() {
  statusCheckerCnt++;

  if (+new Date() - statusCheckerStartAt >= 10000) {
    openModal(checkFailUrl);
    return;
  }

  // first set next call
  statusCheckerTimer = setTimeout(function(){
    statusChecker();
  }, statusCheckerCnt * 1100);

    api({
    url: checkerUrl,
    type: 'get'
  }).then((response) => {
    const data          = response.data;

      if (data.status !== undefined) {
        var status = parseInt(data.status);

        if (status !== subscriptionStatus) {
          // log.print("__userSubscription__", 'new status', status);
          // log.print("__userSubscription__", 'current status', subscriptionStatus);
          KIOSK.reloadWindow('__current_url__');
        }

      }

  })

};

const userSubscription = {
  changeEventName: changeEventName,
};


export default userSubscription;